import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import { SIZES } from '../constants';

import styles from './TextInputContainer.scss';

type TextInputContainerProps = {
    paddingTop?: typeof SIZES.none | typeof SIZES.animatedPlaceholder;
};

export const TextInputContainer: FunctionComponent<TextInputContainerProps> = ({
    children,
    paddingTop,
}) => {
    const className = classnames(styles.textInputWrapper, {
        [styles.animatedPlaceholderPadding]: paddingTop === SIZES.animatedPlaceholder,
    });

    return <div className={className}>{children}</div>;
};
